// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNavView-cls1_Tzj","cls2":"FocusedNavView-cls2_POY FocusedNavView-cls1_Tzj","hasBadge":"FocusedNavView-hasBadge_U7g"};